export default interface ItemIdentifier {
  hostName: string;
  positionNo: string;
}

export function isItemIdentifier(value: unknown): value is ItemIdentifier {
  const result = value as ItemIdentifier;
  return (
    result != null &&
    typeof result === 'object' &&
    typeof result.hostName === 'string' &&
    typeof result.positionNo === 'string'
  );
}

export function toItemIdentifierQueryParam(
  { hostName, positionNo }: ItemIdentifier,
  separator = ' ',
): string {
  return [hostName, positionNo].join(separator);
}

export function toItemIdentifierQueryParams(
  item?: ItemIdentifier | ItemIdentifier[],
): string | string[] | undefined {
  if (Array.isArray(item)) {
    return item.map((i) => toItemIdentifierQueryParam(i));
  }
  if (item != null) {
    return toItemIdentifierQueryParam(item);
  }
  return undefined;
}
